import React, { useState } from "react";
import CardsCripto from "../assets/images/cards-cripto.png";
import CARD from "../assets/images/cards.png";
import CELL from "../assets/images/cell.png";
import IB from "../assets/images/dashboard-descktop.png";
import HE from "../assets/images/he.png";
import CONTACT from "../assets/images/she-cell.png";
import SHE from "../assets/images/she.png";
import TEC from "../assets/images/wiiascend-tecnolog.png";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Icon from "../components/icons/Icon";
import Contact from "./Contact";
import { Link } from "react-router-dom";
import OptionModal from "../components/OptionsModal";
import TiltImage from "../components/image/TiltImage";

const Initial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col p-3 justify-center items-center bg-gradient-to-r from-[#081533] via-[#081533] to-[#1553E0] w-full h-auto">
        <Header />
        <div className="lg:flex lg:flex-col items-center h-auto min-h-[500px] w-full lg:max-w-[900px] p-3 justify-center text-center text-white">
          <div>
            <div>
              <h1 className="text-4xl lg:text-6xl font-bold mt-8 py-2">
                O futuro das finanças já começou. Conecte-se!
              </h1>
            </div>
            <div>
              <p className="text-center text-xl lg:text-2xl py-4">
                <span className="font-bold">
                  Na Wii Ascend Technologies, você acessa uma nova forma de
                  lidar com seu dinheiro:
                </span>
                <span>
                  {" "}
                  Internet Banking completo, Exchange de criptomoedas, e
                  segurança de ponta — tudo em um só lugar, sob o seu controle.
                </span>
              </p>
            </div>
          </div>
          <div className="lg:flex lg:flex-row items-center justify-center gap-6">
            <div className="py-5">
              <button className="bg-white h-12 w-54 text-black py-2 px-6 rounded-full hover:bg-gray-100">
                <Link to="/we" className="text-black">
                  {" "}
                  Explore a plataforma
                </Link>
              </button>
            </div>
            <div>
              <button
                onClick={openModal}
                className="bg-transparent h-12 w-54 text-white py-2 px-6 border-2 border-[#1553E0] rounded-full hover:bg-[#7A5F22]"
              >
                Entre em contato
              </button>
            </div>
          </div>
        </div>

        <div className=" hidden lg:block mb-[-90px] p-16 w-[900px]  items-center justify-center">
          <img src={IB} alt="Imagem" />
        </div>
      </div>

      <div className="lg:flex flex-col w-full h-auto min-h-[3100px] px-20 py-10 justify-center items-center bg-white lg:h-[2000px] lg:min-h-[2000px] lg:min-w-[1024px]">
        <div className="flex flex-col  lg:ml-20  m-4 text-center h-auto w-full items-center justify-center lg:text-start lg:flex-row lg:max-w-[1000px]">
          <div className="h-fit w-auto block lg:hidden">
            <img
              src={TEC}
              alt="Tecnologia financeira"
              className="w-[350px] h-300px"
            />
          </div>

          <div className="flex flex-col items-center ">
            <div className="py-2">
              <h2 className="text-4xl font-bold text-black">
                Tecnologia que te aproxima da liberdade financeira
              </h2>
            </div>
            <div className="py-3">
              <p className="text-xl text-black">
                Não somos apenas uma plataforma. Somos uma nova experiência
                financeira. Unimos inovação, descentralização e segurança para
                transformar sua relação com o dinheiro.
              </p>
            </div>
            <div className="py-3">
              <p className="text-lgtext-black/60">
                Na Wii Ascend, você toma as rédeas da sua vida financeira com
                autonomia e confiança.
              </p>
            </div>
            <div className="py-2 px-6 ">
              <button className="bg-[#9B7B2F] text-white rounded-full hover:bg-[#7A5F22]">
                <Link to="/we" className="text-white">
                  {" "}
                  Saiba mais sobre nossa segurança
                </Link>
              </button>
            </div>
          </div>

          <div className="hidden lg:block m-4 lg:m-0">
            <img
              src={TEC}
              alt="Tecnologia financeira"
              className="w-full h-auto "
            />
          </div>
        </div>

        <div className="w-full lg:max-w-[900px] py-16 px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-black">
              Tudo o que você precisa para viver o digital na prática
            </h2>
          </div>

          <div className="flex flex-col items-center gap-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-[#FAFAFA] shadow-lg rounded-xl p-6 flex flex-col items-center">
                <h3 className="text-xl text-[#081533] font-semibold mb-4">
                  Compra e venda de criptomoedas
                </h3>
                <p className="text-gray-600 text-md">
                  Negócio ativos digitais com facilidade, transparência e taxas
                  que fazem sentido.
                </p>
              </div>

              <div className="bg-[#FAFAFA] shadow-lg rounded-xl p-6 flex flex-col items-center">
                <h3 className="text-xl text-[#081533] font-semibold mb-4">
                  Internet Banking integrado
                </h3>
                <p className="text-gray-600">
                  Pague contas, transfira valores, gerencie sua vida financeira
                  – tudo em um só lugar.
                </p>
              </div>

              <div className="bg-[#FAFAFA] shadow-lg rounded-xl p-6 flex flex-col items-center">
                <h3 className="text-xl text-[#081533] font-semibold mb-4">
                  Cartões em cripto e débito
                </h3>
                <p className="text-gray-600">
                  Use seus ativos digitais em qualquer lugar com segurança e
                  praticidade.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
              <div className="bg-[#FAFAFA] shadow-lg rounded-xl p-6 flex flex-col items-left">
                <h3 className="text-xl text-[#081533] font-semibold mb-4">
                  Área Pix completa
                </h3>
                <p className="text-gray-600">
                  Faça depósitos e saques via PIX diretamente na sua conta Wii
                  Ascend, com a mesma agilidade que você já conhece.
                </p>
              </div>

              <div className="bg-[#FAFAFA] shadow-lg rounded-xl p-6 flex flex-col items-left">
                <h3 className="text-xl text-[#081533] font-semibold mb-4">
                  Transações tradicionais
                </h3>
                <p className="text-gray-600">
                  TED, depósitos e saques com a praticidade de uma conta digital
                  e a liberdade do universo cripto. Tudo em um só lugar, simples
                  e seguro.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="h-screen lg:h-fit w-fit lg:w-[900px] bg-white py-10 px-8">
          <div className="flex flex-col lg:flex-row gap-4 items-center justify-between">
            <div>
              <img
                src={SHE}
                alt="Segurança e Controle"
                className="w-[800px] h-auto rounded-xl"
              />
            </div>
            <div className="font-bold text-left items-center justify-center mb-8 lg:mb-0">
              <h2 className="text-3xl font-bold text-[#081533] mb-4">
                Controle absoluto e segurança total
              </h2>
              <p className="text-lg text-black font-normal mb-6">
                Segurança não é um diferencial. É pré-requisito.
              </p>
              <p className="text-lg text-[#081533]/70 font-light mb-6">
                Na Wii Ascend, seus dados e ativos estão protegidos com as
                tecnologias mais avançadas do setor financeiro.
              </p>
              <button className="bg-[#9B7B2F] text-white py-2 px-6 rounded-full hover:bg-[#7A5F22]">
                <Link to="/we" className="text-white">
                  {" "}
                  Saiba mais sobre nossa segurança
                </Link>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col h-fit lg:h-[1490px]  items-center text-center justify-between bg-gradient-to-r from-[#081533] via-[#081533] lg:via-[#183f9a] to-[#081533] py-10 px-9 w-full lg:min-w-[1024px]">
        <div className="relative top-[-100px] lg:top-[-130px] w-auto lg:w-[768px] h-auto ">
          <img
            src={CARD}
            alt="Imagem dos cartões"
            className="w-[450px] h-[390px] lg:w-[850px] lg:h-[850px] rounded-xl"
          />
        </div>

        <div className="relative top-[-180px] lg:top-[-290px] left-0 w-full text-center text-white p-6">
          <h2 className="text-lg lg:text-6xl font-bold mb-4">
            Um app, todos os seus ativos.{" "}
            <span className="text-[#1553E0]">Sempre com você</span>
          </h2>
          <p className="text-lg text-white/70 font-light lg:mb-6">
            Com nosso aplicativo, você movimenta seu dinheiro, acompanha
            investimentos e realiza pagamentos — tudo com poucos toques.
          </p>
        </div>

        <div className="relative top-[-180px] lg:top-[-290px] flex-col  lg:mb-[20px] items-center justify-between">
          <div className="w-[778px] mb-8 hidden lg:block">
            <img src={CELL} alt="Imagem" className="w-full h-auto rounded-xl" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            <div className="bg-[#081533] h-fit items-center border border-[#0f3ca3] p-6 rounded-xl shadow-lg text-center flex justify-between flex-row">
              <div>
                <h3 className="text-lg font-normal text-white text-left">
                  Interface intuitiva <br />e responsiva
                </h3>
              </div>
              <div>
                <Icon name="Interruptor" className="mx-auto mb-4" />
              </div>
            </div>

            <div className="bg-[#081533] h-fit items-center justify-between border border-[#0f3ca3] p-6 rounded-xl shadow-lg text-center flex flex-row">
              <div>
                <h3 className="text-lg text-white font-normal text-left">
                  Exchange e Internet <br />
                  Banking integrados
                </h3>
              </div>
              <div>
                <Icon name="VemVai" className="mx-auto mb-4" />
              </div>
            </div>

            <div className="bg-[#081533] h-fit items-center border border-[#0f3ca3] p-6 rounded-xl shadow-lg text-center flex justify-between flex-row">
              <div>
                <h3 className="text-lg text-white font-normal text-left">
                  Extrato consolidado <br />
                  (FIAT + Cripto)
                </h3>
              </div>
              <div>
                <Icon name="MoneyCircle" className="mx-auto mb-4" />
              </div>
            </div>

            <div className="bg-[#081533] h-fit items-center border border-[#0f3ca3] p-6 rounded-xl shadow-lg text-center flex justify-between flex-row">
              <div>
                <h3 className="text-lg text-white font-normal text-left">
                  Alertas e insights
                  <br /> em tempo real
                </h3>
              </div>
              <div>
                <Icon name="Sino" className="mx-auto mb-4" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center bg-white p-8 lg:p-20 lg:min-w-[1024px]">
        <div className="flex flex-row w-[900px] bg-[#081533] rounded-2xl p-8">
          <div className=" text-center lg:text-left py-8 lg:py-0">
            <h2 className="text-3xl text-white font-bold mb-4">
              Multiplique possibilidades com Inteligência e segurança
            </h2>
            <p className="text-lg text-white font-normal mb-4">
              Aqui, investir vai além do tradicional.
            </p>
            <p className="text-lg text-white/70 font-light mb-8">
              Oferecemos caminhos estratégicos para quem quer crescer com
              estabilidade e visão de futuro.
            </p>

            <div className="flex flex-col items-center gap-4 lg:items-start">
              <div className="flex flex-row gap-2 bg-[#887443] h-24 lg:h-fit text-white py-2 px-6 rounded-3xl hover:bg-[#7A5F22] w-full lg:w-auto">
                <Icon name="Arrow" className="w-5 h-5" />
                Staking com rendimentos passivos
              </div>
              <div className="flex flex-row gap-2 bg-[#887443] h-24 lg:h-fit text-white py-2 px-6 rounded-3xl hover:bg-[#7A5F22] w-full lg:w-auto">
                <Icon name="Arrow" className="w-5 h-5" /> Tokenização de ativos
                reais
              </div>
              <div className="flex flex-row gap-2 bg-[#887443] h-24 lg:h-fit text-white py-2 px-6 rounded-3xl hover:bg-[#7A5F22] w-full lg:w-auto">
                <Icon name="Arrow" className="w-5 h-5" /> Criptomoedas com alto
                potencial
              </div>
              <div className="flex flex-row gap-2 bg-[#887443] lg:h-24 h-30 lg:h-fit text-white py-2 px-6 rounded-3xl hover:bg-[#7A5F22] w-full lg:w-auto">
                <Icon name="Arrow" className="w-5 h-5" /> Soluções exclusivas
                para empresas <br /> e investimentos institucionais
              </div>
            </div>

            <div className="py-4">
              <button className="bg-white text-[#081533] py-2 px-6 rounded-full hover:bg-gray-100">
                <Link to="/token" className="text-[#081533]">
                  {" "}
                  Descubra onde investir com confiança
                </Link>
              </button>
            </div>
          </div>

          <div className="left-[32px] relative justify-end bottom-[-112px] hidden lg:block">
            <img src={HE} alt="Imagem" className="h-[600px] w-[800px]" />
          </div>
        </div>
      </div>
      <div
        className="flex flex-col justify-center items-center bg-[#081533] p-8 lg:min-w-[1024px]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 10%, rgba(21, 83, 224, 1) 5%, rgba(8, 21, 51, 0.8) 40%, rgba(8, 21, 51, 0.5) 80%), radial-gradient(circle at 30% 50%, rgba(21, 83, 224, 0.6) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.3) 80%), radial-gradient(circle at 70% 70%, rgba(21, 83, 224, 0.7) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.4) 80%)",
          position: "relative",
        }}
      >
        {/* <div className="flex flex-row items-left justify-left">
       <div>
       <button className="bg-transparent border border-[#0f3ca3] h-12 w-54 text-black py-2 px-6 rounded-full hover:bg-[#0f3ca3]-100">
              <Link to="/we" className="text-[#79A2FF]">
                {" "}
                Sobre a Wii Ascend
              </Link>
          </button>
       </div>
        </div> */}

        <div className="flex w-full m-5 p-5 lg:w-[900px] flex-col lg:flex-row items-center justify-between">
          <div className="block lg:hidden w-auto h-auto mb-20">
            <TiltImage />
          </div>

          <div className="text-center lg:text-left text-white mb-8 lg:mb-0">
            <h2 className="text-4xl font-bold mb-6">
              Uma fintech feita para o agora. E preparada para o amanhã!
            </h2>
            <p className="text-lg text-[#79A2FF] mb-6">
              Fundada em 2025, a Wii Ascend nasceu com uma missão clara: unir o
              melhor do mercado financeiro tradicional com a revolução digital.
            </p>
            <p className="text-lg mb-6">
              Somos pioneiros em soluções Web3 que colocam a liberdade nas mãos
              das pessoas.
            </p>
            <p className="text-lg mb-6">
              Tecnologia, segurança e acessibilidade — para todos, sem exceção.
            </p>
          </div>

          <div className="hidden lg:block w-full ml-10">
            <TiltImage />
          </div>
        </div>

        <div className="flex w-fit lg:w-[900px] flex-col items-center justify-center text-center text-white">
          <div className="hidden lg:block">
            <img
              src={CONTACT}
              alt="Imagem do atendimento"
              className="w-[600px] h-[400px] "
            />
          </div>

          <h2 className="hidden lg:block text-3xl text-[#144dd2] font-bold mb-3 my-6">
            Atendimento humano.
          </h2>
          <h2 className="hidden lg:block w-[400px]  text-3xl font-bold mb-6">
            Porque você merece mais que um chatbot
          </h2>
          <p className="hidden lg:block w-[400px] text-white/6sobre0 text-lg mb-6">
            A dúvida bateu? Precisa de orientação? Nosso time está sempre pronto
            para te ajudar com empatia e conhecimento real.
          </p>

          <div className="hidden lg:block">
            <div className="flex flex-row gap-8 mb-6  ">
              <a
                href="https://wa.me/554891081427"
                target="_blank"
                className="bg-[#887443] text-white items-center justify-center rounded-full"
              >
                <Icon name="Whatsapp" className="text-white w-8 h-8 m-3" />
              </a>
              <a
                href="https://www.linkedin.com/company/wiiascend/posts/?feedView=all"
                target="_blank"
                className="bg-[#887443] rounded-full"
              >
                <Icon name="Linkedin" className="text-white w-8 h-8 m-3" />
              </a>
              {/* <a
                href="https://t.me/seu-usuario"
                target="_blank"
                className="bg-[#887443] rounded-full"
              >
                <Icon name="Telegram" className="text-white w-8 h-8 m-3" />
              </a> */}
              <a
                href="https://www.instagram.com/wiiascend?igsh=aW5tZG1vcHU1Z2R4"
                target="_blank"
                className="bg-[#887443] rounded-full"
              >
                <Icon name="Instagram" className="text-white w-8 h-8 m-3" />
              </a>
              <a
                href="mailto:contato@wiiascend.com?subject=Gostaria de conhecer a Wii Ascend&body=Olá! Eu gostaria de obter mais informações sobre os serviços da Wii Ascend."
                className="bg-[#887443] rounded-full"
                rel="noopener noreferrer"
              >
                <Icon name="Email" className="text-white w-8 h-8 m-3" />
              </a>
            </div>
          </div>

          <button className="bg-[#887443] text-white py-2 px-6 rounded-full " onClick={openModal}>
            Fale com a Wii Ascend agora
          </button>
        </div>
      </div>
      <Footer />
      <OptionModal isOpen={isModalOpen} closeModal={closeModal} />
    </div>
  );
};

export default Initial;
